// extracted by mini-css-extract-plugin
module.exports = {"root":"seventh_root__2fR87","check":"seventh_check__7Fisw"};